import { fixMath } from "./fixMath";

// https://docs.stripe.com/currencies#zero-decimal
// Zero-decimal currencies
const ZERO_DECIMAL_CURRENCIES = new Set([
    'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW',
    'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV',
    'XAF', 'XOF', 'XPF'
]);


// List of special case currencies that should be treated as zero-decimal
const SPECIAL_ZERO_DECIMAL_CURRENCIES = new Set([
    'ISK', // Icelandic Króna - technically has 2 decimals but used as zero-decimal
    // Note: HUF and TWD are special cases for payouts but use 2 decimals for charges
]);

// Format the amount for Stripe based on currency
export function formatAmountForStripe(amount: number, currency: string): number {
    const lowerCaseCurrency = currency.toUpperCase();

    if (
        ZERO_DECIMAL_CURRENCIES.has(lowerCaseCurrency) ||
        SPECIAL_ZERO_DECIMAL_CURRENCIES.has(lowerCaseCurrency)
    ) {
        return Math.round(amount);
    }
    return Math.round(fixMath.multiply(amount, 100));
}

export function formatAmountFromStripe(amount: number, currency: string): number {
    const roundCount = getRoundCount(currency);
    return amount / Math.pow(10, roundCount);
}

export function getRoundCount(currency: string): number {
    const lowerCaseCurrency = currency.toUpperCase();

    if (
        ZERO_DECIMAL_CURRENCIES.has(lowerCaseCurrency) ||
        SPECIAL_ZERO_DECIMAL_CURRENCIES.has(lowerCaseCurrency)
    ) {
        return 0;
    }
    return 2;
}

// round to given decimal places (matches SQLite ROUND behavior)
export function roundDecimalPlaces(amount: number, decimalPlaces: number): number {
    // Use Number.parseFloat and toFixed to avoid floating point precision issues
    const factor = Math.pow(10, decimalPlaces);
    return Number.parseFloat((Math.round(amount * factor) / factor).toFixed(decimalPlaces));
}